
// Individual service exports for convenience
import Module1Service from './module1Service';
import module2Service from './module2Service';
import Module3Service from './module3Service';
import module4Service from './module4Service';
import semanticService from './semanticService';

// Make sure we export instances, not classes
const module1ServiceInstance = Module1Service.getInstance();
const module3ServiceInstance = Module3Service.getInstance();

// Export services
export { 
  module1ServiceInstance as module1Service, 
  module2Service, 
  module3ServiceInstance as module3Service,
  module4Service,
  semanticService
};

// Re-export types from module1Service with aliases to avoid ambiguity
export type { 
  BusinessConfig as Module1BusinessConfig, 
  AnalysisRequest, 
  AnalysisStatus, 
  AnalysisResponse
} from './module1Service';

// Re-export types from module2Service
export type {
  CodeGenerationRequest,
  CodeGenerationStatus,
  CodeExecutionRequest,
  CodeExecutionResult
} from './module2Service';

// Re-export types and hooks from module3Service (legacy)
export type { 
  SemanticAnalysisRequest as Module3SemanticAnalysisRequest
} from './module3Service';

export {
  useStartSemanticAnalysisDb,
  useGetSemanticAnalysisStatusDb,
  useGetFrameworkByModuleId
} from './module3Service';

// Re-export types and hooks from semanticService (new implementation)
export type {
  SemanticAnalysisRequest,
  SemanticAnalysisStatus,
  SemanticFramework,
  ExportModule4Request
} from './semanticService';

export {
  useStartSemanticAnalysis,
  useGetSemanticAnalysisStatus,
  useGetSemanticAnalysisByWorkflow,
  useGetSemanticFramework,
  useExportToModule4
} from './semanticService';

// Re-export hooks from module2Service
export {
  useGenerateCodeDb,
  useGetCodeGenerationStatusDb,
  useGetCodeDb,
  useExecuteCodeDb,
  useGetExecutionStatusDb
} from './module2Service';

// Re-export types from module4Service
export type {
  JobListParams,
  JobCreationRequest,
  ClientConfig,
  PromptConfig,
  ResultsConfig,
  JobDetails
} from './module4Service';

export { 
  useExportFrameworkToModule4,
  useGetAllFrameworks
} from './module3Service'; // Keep these exports from module3Service for backward compatibility

export { useGetBlobFiles } from './blobService';
